export enum ScreensColumnsChooserBlock {
  Root = 'ViewColumnsChooser',
}
